"use client";

import { useSearchParams } from "next/navigation";

import { useLang } from "@/hooks/use-lang";
import { useUpdateQuery } from "@/hooks/use-update-query";

import { ToggleButtons } from "ui/widget/toggle-buttons";

import { getTop20CostEstimationOptions } from "../../../data/top20-cost-estimation-options";
import { Top20TableData } from "../../../services/get-investor-top20-table";
import { Top20CostEstimationGraph } from "./Top20CostEstimationGraph";
import { Top20CostEstimationTable } from "./Top20CostEstimationTable";

type Props = {
  investor: string;
  tableData: Top20TableData;
};

export const Top20CostEstimationComponent = ({
  investor,
  tableData,
}: Props) => {
  const { t } = useLang();
  const top20CostEstimationOptions = getTop20CostEstimationOptions({ t });
  const { updateQuery } = useUpdateQuery();
  const searchParams = useSearchParams();
  const top20CostEstimationIndex = +(
    searchParams.get("top20-cost-estimation-index") ?? 0
  );
  const selectedOption =
    top20CostEstimationOptions[top20CostEstimationIndex].value;

  return (
    <>
      <div className="flex flex-wrap justify-between gap-y-4">
        <ToggleButtons
          className="-ml-2 w-fit"
          itemClassName="text-neutral-400 py-1"
          selectedItemClassName="text-sky-700 py-1"
          options={top20CostEstimationOptions}
          value={selectedOption}
          onChange={(value) => {
            const index = top20CostEstimationOptions.findIndex(
              (o) => o.value === value
            );
            updateQuery({
              name: "top20-cost-estimation-index",
              value: index.toString(),
            });
          }}
          id="top20-cost-estimation-category"
        />
        {selectedOption === top20CostEstimationOptions[1].value && (
          <div className="text-start text-xs font-medium text-neutral-500 @xs:text-end">
            <p className="text-sm">
              {tableData.closeDate != null &&
                `${t.analysis.shared.price} ${t.analysis.shared.date}：${tableData.closeDate}`}
            </p>
            <p className="text-sm">
              {tableData.costDate != null &&
                `${t.my13F.investor.estimation} ${t.analysis.shared.date}：${tableData.costDate}`}
            </p>
          </div>
        )}
      </div>
      {selectedOption === top20CostEstimationOptions[0].value ? (
        <Top20CostEstimationGraph investor={investor} />
      ) : (
        <Top20CostEstimationTable tableData={tableData} />
      )}
    </>
  );
};
